/* ==========================================================================
   Conquest — facets.js
   Progressive storefront filtering. Without JS the form submits normally.
   ========================================================================== */
(() => {
  const Conquest = (window.Conquest = window.Conquest || {});

  const render = async (url, push = true) => {
    const results = document.querySelector('[data-facets-results]');
    if (!results) return;
    results.classList.add('is-loading');
    const target = new URL(url, window.location.origin);
    target.searchParams.set('section_id', results.dataset.section);
    try {
      const html = await (await fetch(target.toString())).text();
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-facets-results]');
      if (!next) { window.location = url; return; }
      const open = Array.from(results.querySelectorAll('details[data-facet][open]')).map((d) => d.querySelector('summary').textContent.trim());
      results.innerHTML = next.innerHTML;
      results.querySelectorAll('details[data-facet]').forEach((d) => {
        if (open.includes(d.querySelector('summary').textContent.trim())) d.open = true;
      });
      if (push) window.history.pushState({ facets: true }, '', url);
      const count = results.querySelector('.collection__count');
      if (count) Conquest.announce(count.textContent);
    } catch (e) {
      window.location = url;
    } finally {
      results.classList.remove('is-loading');
    }
  };

  const urlFromForm = (form) => {
    const params = new URLSearchParams(new FormData(form));
    for (const [key, value] of Array.from(params.entries())) if (value === '') params.delete(key);
    return `${form.getAttribute('action') || window.location.pathname}?${params.toString()}`;
  };

  const debounced = Conquest.debounce ? Conquest.debounce((form) => render(urlFromForm(form)), 400) : (form) => render(urlFromForm(form));

  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (!form) return;
    if (e.target.type === 'number') debounced(form);
    else render(urlFromForm(form));
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    render(urlFromForm(form));
  });
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-facet-remove]');
    if (!link) return;
    e.preventDefault();
    render(link.href);
  });
  /* Close other filter dropdowns when one opens */
  document.addEventListener('toggle', (e) => {
    if (!e.target.matches || !e.target.matches('details[data-facet]') || !e.target.open) return;
    document.querySelectorAll('details[data-facet][open]').forEach((d) => { if (d !== e.target) d.open = false; });
  }, true);
  window.addEventListener('popstate', (e) => { if (e.state && e.state.facets) render(window.location.href, false); });
})();
